import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authReducer';
import marketReducer from './marketReducer';
import uiReducer from './uiReducer';
import watchlistReducer from './watchlistReducer';
import portfolioReducer from './portfolioReducer';
import ordersReducer from './orderReducer'
import searchReducer from './searchReducer'
import addOrderReducer from './addorderReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  market: marketReducer,
  ui: uiReducer,
  watchlist: watchlistReducer,
  portfolio: portfolioReducer,
  orders: ordersReducer,
  search: searchReducer,
  addorder: addOrderReducer
});

export default rootReducer;